import { Grid, FormControlLabel, IconButton, Box } from "@mui/material";
import React from "react";
import { aboutMeInformation, contacts, MINIMUM_CLIENT_WIDTH, resumeUrl } from "../../information/information";
import ResumeIcon from "../SVGIcon/Resume";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import './ContactList.css'

function ContactList(){
    const { website, phoneNumber, gmail } = contacts;
    const isPhoneView = window.innerWidth <=MINIMUM_CLIENT_WIDTH;
    const contactsWeb = website.map(({ url, name, icon }) => {
      return (
        <Grid item key={Math.random()}>
          <FormControlLabel
            onClick={() => window.open(url)}
            control={<IconButton>{icon}</IconButton>}
            label={name}
          />
        </Grid>
      );
    }, []);
    if (resumeUrl.length != 0) {
      contactsWeb.push(
        <Grid item key={resumeUrl}>
          <FormControlLabel
            onClick={() => window.open(resumeUrl)}
            control={<IconButton>{ResumeIcon}</IconButton>}
            label="Resume"
          />
        </Grid>
      );
    }
    if (gmail || phoneNumber) {
        if(!isPhoneView){
            
      contactsWeb.push(
        <React.Fragment key={Math.random()}>
          <Box className={"contact_divider_horizontal"} sx={{ backgroundColor: "divider" }} />
        </React.Fragment>
      );
        }
      if (gmail)
        contactsWeb.push(
          <Grid item key={Math.random()}>
            <FormControlLabel
              onClick={() => window.open(`mailto:${gmail}`)}
              control={
                <IconButton>
                  <EmailIcon />
                </IconButton>
              }
              label={gmail}
            />
          </Grid>
        );
      if (phoneNumber)
        contactsWeb.push(
          <Grid item key={Math.random()}>
            <FormControlLabel
              onClick={() => window.open(`tel:${phoneNumber}`)}
              control={
                <IconButton>
                  <LocalPhoneIcon />
                </IconButton>
              }
              label={phoneNumber}
            />
          </Grid>
        );
    }
    return <Grid id='ContactList' container direction={isPhoneView?"row":"column"}>
          {isPhoneView && <Grid item xs={12} className={"contact_divider_horizontal"} sx={{ backgroundColor: "divider" }} />}
        {!isPhoneView&&
              <img
                referrerPolicy="no-referrer"
                src={aboutMeInformation.urlImg}
                alt="picture of me"
                className="article_picture"
                loading="lazy"
              />
           }
        {contactsWeb}
          </Grid>
}
export default ContactList;